import {HttpErrorResponse} from '@angular/common/http';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ProductsService, QuoteOrderSampleService} from 'src/app/admin-core/apiservices';
import {CarrierService} from 'src/app/admin-core/apiservices/carrier.service';
import {MilestoneStatusService} from 'src/app/admin-core/apiservices/milestone-status.service';
import {QuoteService} from 'src/app/admin-core/apiservices/quote.service';
import {Constants} from 'src/app/admin-core/constants';
import {RequestParamModel} from 'src/app/admin-core/models';
import {AlertService, HelperService} from 'src/app/admin-core/services';
import {FormAutofocusDirective} from '../../../shared/directives/form-autofocus.directive';

@Component({
  hostDirectives: [FormAutofocusDirective],
  standalone: false,
    selector: 'app-choose-carrier-modal',
    // Eager: Angular 22 defaults every component to OnPush, which would leave this view
    // unpainted after its subscribe callbacks (see app.component.ts for the full note).
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './choose-carrier-modal.component.html',
    styleUrls: ['./choose-carrier-modal.component.css']
})
export class ChooseCarrierModalComponent implements OnInit {
  /* ################### Variable Declaration Start ################### */
  @Input() quoteOrderModel!: any;
  isLoading = false;
  carrierForm!: UntypedFormGroup;
  submitted: boolean = false;
  carriers: any;
  regions: any;
  is_show_add_carrier = false;
  is_selected = false;
  isCarrierSelected: any = 0;
  // productList: any = []
  is_selected_addtional_charge = false
  previousCratesValue: any = null;
  previousDeliveryChargesValue: any = null;

    /* ################### Variable Declaration End ################### */

    constructor(
        public fb: UntypedFormBuilder,
        public ngbActiveModal: NgbActiveModal,
        private quoteOrderSampleService: QuoteOrderSampleService,
        private carrierService: CarrierService,
        public alertService: AlertService,
        private helperService: HelperService,
        public changeDetection: ChangeDetectorRef,
        private productService: ProductsService,
        private quoteService: QuoteService,
        private statusService: MilestoneStatusService
    ) {
    }

    /************************************
     * Life cycle hooks start
     ************************************/
    ngOnInit(): void {
        this.getCarrierList();
        this.getRegionsList();
        // this.getProduct();
        this.carrierForm = this.fb.group({
            carrier_id: new UntypedFormControl(this.quoteOrderModel.carrier_id ?? null, [Validators.required]),
            company_name: new UntypedFormControl('', []),
            contact_name: new UntypedFormControl('', []),
            contact_mobile_number: new UntypedFormControl('', []),
            dispatch_email: new UntypedFormControl('', []),
            applicable_regions: new UntypedFormControl('', []),
            own_transport: [this.quoteOrderModel.is_used_own_transport ? true : false],
            delivery_charges: [this.quoteOrderModel.delivery_charge ?? null],
            crates: [this.quoteOrderModel.crates ?? null],
            // product: []
        })

        if (this.quoteOrderModel.is_used_own_transport) {
            this.is_selected = true;
            this.carrierForm?.get('carrier_id')!.clearValidators();
            this.carrierForm?.get('carrier_id')!.setErrors(null);
            this.carrierForm?.get('carrier_id')!.updateValueAndValidity();
            this.carrierForm?.get('carrier_id')!.setValue(null);
            if (this.quoteOrderModel.delivery_charge) {
                this.is_selected_addtional_charge = true;
            }
        } else {
            this.carrierForm?.get('carrier_id')!.setValidators(Validators.required);
            this.isCarrierSelected = null
            this.is_selected = false;
            if (this.quoteOrderModel.delivery_charge || this.quoteOrderModel.delivery_charge === 0) {
                this.is_selected_addtional_charge = true;
                this.carrierForm?.get('delivery_charges')!.setValidators(Validators.required);
            }
        }
    }

    /************************************
     * Life cycle hooks end
     ************************************/


    /************************************
     * Other functions start
     ************************************/
    getCarrierList() {
        this.changeDetection.markForCheck();
        this.carriers = [];
        this.isLoading = true;
        let requestParamModel = new RequestParamModel();

        requestParamModel.pageSize = 'all'
        // requestParamModel.addDefaultFilter('is_deleted', 0, 'number');
        this.carrierService.getCarriers(requestParamModel).subscribe((dataList: any) => {
            this.isLoading = false;
            this.carriers = dataList.data;
            this.selectAllForDropdownItems(this.carriers);
        }, (error: HttpErrorResponse) => {
            this.isLoading = false;
        });
    }

    getRegionsList() {
        this.changeDetection.markForCheck();
        this.regions = [];
        this.isLoading = true;
        const requestParamModel = new RequestParamModel();
        requestParamModel.pageSize = Constants.PAGE_SIZE_ALL;
        this.carrierService.getRegions(requestParamModel).subscribe((dataList: any) => {
            this.isLoading = false;
            this.regions = dataList;
        }, (error: HttpErrorResponse) => {
            this.isLoading = false;
        });
    }

    onChangeProduct(event: any) {
    }

    hideShowAddCarrierData() {
        this.is_show_add_carrier = !this.is_show_add_carrier;

        if (this.is_show_add_carrier) {
            this.carrierForm.controls['carrier_id'].disable();
            this.carrierForm.get('company_name')?.setValidators([Validators.required]);
            this.carrierForm.get('contact_name')?.setValidators([Validators.required]);
            this.carrierForm.get('contact_mobile_number')?.setValidators([Validators.maxLength(10), Validators.minLength(10), this.mobileValidator.bind(this)]);
            this.carrierForm.get('dispatch_email')?.setValidators([Validators.required, Validators.email, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]);
            this.carrierForm.get('applicable_regions')?.setValidators([Validators.required]);
            this.carrierForm?.get('carrier_id')!.clearValidators();

            this.changeDetection.markForCheck()
        } else {
            this.carrierForm.controls['carrier_id'].enable();

            this.carrierForm.get('company_name')!.clearValidators();
            this.carrierForm.get('contact_name')!.clearValidators();
            this.carrierForm.get('contact_mobile_number')!.clearValidators();
            this.carrierForm.get('dispatch_email')!.clearValidators();
            this.carrierForm.get('applicable_regions')!.clearValidators();
            this.carrierForm.get('carrier_id')?.setValidators([Validators.required]);

            this.changeDetection.markForCheck()
        }

        this.carrierForm.get('company_name')?.updateValueAndValidity()
        this.carrierForm.get('contact_name')?.updateValueAndValidity()
        this.carrierForm.get('contact_mobile_number')?.updateValueAndValidity()
        this.carrierForm.get('dispatch_email')?.updateValueAndValidity()
        this.carrierForm.get('applicable_regions')?.updateValueAndValidity()
        this.carrierForm.get('carrier_id')?.updateValueAndValidity()
    }

    private mobileValidator(control: UntypedFormControl): { [key: string]: boolean } | null {
        const value = control.value?.trim(); // Trim whitespace for safety

        if (!value) {
            return null; // Allow null or empty values
        }
        const isMobile = /^04\d{8}$/.test(value); // Australian mobile: Starts with '04' + 8 digits
        const isLandline = /^(0[2|3|7|8])\d{8}$/.test(value); // Australian landline: Starts with 02, 03, 07, or 08 + 8 digits
        return isMobile || isLandline ? null : {mobileNotValid: true}; // Return error only if invalid
    }

    get cf() {
        return this.carrierForm.controls
    }

    onSubmit() {
        this.submitted = true;
        if (this.carrierForm.invalid) {
            return;
        }
        this.isLoading = true;
        // let selectedProductIds: number[] = this.carrierForm.value.product || [];
        const isOwnTransport = this.cf.own_transport.value;

        let requestModel: any = {
            // product_ids: selectedProductIds,
            delivery_charges: this.cf.delivery_charges.value,
            crates: this.cf.crates.value
        };

        if (this.is_show_add_carrier) {
            const requestModel: any = {
                company_name: this.cf.company_name.value,
                contact_name: this.cf.contact_name.value,
                contact_mobile_number: this.cf.contact_mobile_number.value,
                dispatch_email: this.cf.dispatch_email.value,
                applicable_regions: this.cf.applicable_regions.value
            };

            this.carrierService.createCarrier(requestModel).subscribe((data: any) => {
                const carrierId = data?.id ?? 0;
                if (this.quoteOrderModel.quote_schedule_delivery_id) {
                    this.updateQuoteScheduleDelivery(carrierId, isOwnTransport);
                } else {
                    this.updateQuote(carrierId, isOwnTransport);
                }
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.submitted = false;
                if (error.status == 422) {
                    let self = this;
                    if (error.error.data.length > 0) {
                        Object.keys(error.error.data).forEach(function (key, data) {
                            self.carrierForm.controls[error.error.data[key].field].setErrors({'apiError': error.error.data[key].message});
                        });
                        return;
                    }
                }

                this.ngbActiveModal.close(true);
                this.helperService.handleError(error);
            })
        } else {
            if (this.quoteOrderModel.quote_schedule_delivery_id) {
                this.updateQuoteScheduleDelivery(0, isOwnTransport);
            } else {
                this.updateQuote(0, isOwnTransport);
            }
        }
    }

    updateQuote(carrier_id: any, isOwnTransport: any) {
        const quoteRequestModel: any = {
            carrier_id: isOwnTransport ? null : (carrier_id !== 0 ? carrier_id : this.carrierForm.controls.carrier_id.value),
            is_used_own_transport: isOwnTransport,
        };
        this.quoteService.quoteScheduleDelivery(quoteRequestModel, this.quoteOrderModel.quote_address?.[0]?.quote_schedule_delivery?.[0]?.id).subscribe({
            next: () => {
                if (isOwnTransport) {
                    // this.alertService.success(Constants.CARRIER_QUOTE_UPDATED);
                    const quoteStatusRequestData = {
                        id: this.quoteOrderModel.id,
                        quote_status: Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT,
                        quote_schedule_delivery_id: this.quoteOrderModel.quote_schedule_delivery_id
                    };
                    this.statusService.changeOrderStatus(quoteStatusRequestData).subscribe({
                        next: () => {
                            this.alertService.success(Constants.ORDER_STATUS_CHANGE_SUCCESS);
                            this.ngbActiveModal.close({is_used_own_transport: true});
                            this.isLoading = false;
                        },
                        error: (error: HttpErrorResponse) => {
                            this.isLoading = false;
                            this.ngbActiveModal.close({is_used_own_transport: true});
                            this.helperService.handleError(error);
                        }
                    });
                } else {
                    const quoteStatusRequestData = {
                        id: this.quoteOrderModel.id,
                        quote_status: Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT,
                        quote_schedule_delivery_id: this.quoteOrderModel.quote_schedule_delivery_id
                    };

                    this.statusService.changeOrderStatus(quoteStatusRequestData).subscribe({
                        next: () => {
                            this.alertService.success(Constants.ORDER_STATUS_CHANGE_SUCCESS);
                            this.ngbActiveModal.close({is_used_own_transport: false});
                            this.isLoading = false;
                        },
                        error: (error: HttpErrorResponse) => {
                            this.isLoading = false;
                            this.ngbActiveModal.close({is_used_own_transport: false});
                            this.helperService.handleError(error);
                        }
                    });
                }
            },
            error: (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.ngbActiveModal.close(true);
                this.helperService.handleError(error);
            }
        });
    }

    updateQuoteScheduleDelivery(carrier_id: any, isOwnTransport: any) {
        const quoteRequestModel: any = {
            carrier_id: isOwnTransport ? null : (carrier_id !== 0 ? carrier_id : this.carrierForm.controls.carrier_id.value),
            is_used_own_transport: isOwnTransport,
            delivery_charge: this.is_selected ? 0 : (this.cf.delivery_charges.value || this.cf.delivery_charges.value === 0) ? this.cf.delivery_charges.value : null,
            is_manual_shipping_rate_change: !this.is_selected && this.cf.delivery_charges.value != this.quoteOrderModel.delivery_charge
        };
        if (this.cf.crates.value) {
            quoteRequestModel.crates = this.cf.crates.value;
        }
        // if (this.cf.delivery_charges.value) {
        //   quoteRequestModel.delivery_charge = this.cf.delivery_charges.value;
        // }

        this.quoteService.quoteScheduleDelivery(quoteRequestModel, this.quoteOrderModel.quote_schedule_delivery_id).subscribe({
            next: () => {
                if (isOwnTransport) {
                    // this.alertService.success(Constants.CARRIER_QUOTE_UPDATED);
                    const quoteStatusRequestData = {
                        id: this.quoteOrderModel.id,
                        status: Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT,
                        quote_schedule_delivery_id: this.quoteOrderModel.quote_schedule_delivery_id
                    };
                    this.statusService.changeQuoteProductStatus(quoteStatusRequestData).subscribe({
                        next: () => {
                            this.alertService.success(Constants.ORDER_STATUS_CHANGE_SUCCESS);
                            this.ngbActiveModal.close({is_used_own_transport: true});
                            this.isLoading = false;
                        },
                        error: (error: HttpErrorResponse) => {
                            this.isLoading = false;
                            this.ngbActiveModal.close({is_used_own_transport: true});
                            this.helperService.handleError(error);
                        }
                    });
                    // this.ngbActiveModal.close({ is_used_own_transport: true });
                    // this.isLoading = false;
                } else {
                    const quoteStatusRequestData = {
                        id: this.quoteOrderModel.id,
                        status: Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT,
                        quote_schedule_delivery_id: this.quoteOrderModel.quote_schedule_delivery_id
                    };

                    this.statusService.changeQuoteProductStatus(quoteStatusRequestData).subscribe({
                        next: () => {
                            this.alertService.success(Constants.ORDER_STATUS_CHANGE_SUCCESS);
                            this.ngbActiveModal.close({is_used_own_transport: false});
                            this.isLoading = false;
                        },
                        error: (error: HttpErrorResponse) => {
                            this.isLoading = false;
                            this.ngbActiveModal.close({is_used_own_transport: false});
                            this.helperService.handleError(error);
                        }
                    });
                }
            },
            error: (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.ngbActiveModal.close(true);
                this.helperService.handleError(error);
            }
        });
    }

    selectAllForDropdownItems(items: any[]) {
        let allSelect = (items: any) => {
            items.forEach((element: any) => {
                element['selectedAllGroup'] = 'selectedAllGroup';
            });
        };

        allSelect(items);
    }

  toggleOwnTransportOption(event: any) {
    if (event.target.checked) {
      this.is_selected = true;
      // Store current values before clearing
      this.previousCratesValue = this.carrierForm?.get('crates')!.value;
      if (this.is_selected_addtional_charge) {
        this.previousDeliveryChargesValue = this.carrierForm?.get('delivery_charges')!.value;
      }    
      this.carrierForm?.get('carrier_id')!.clearValidators();
      this.carrierForm?.get('carrier_id')!.setErrors(null);
      this.carrierForm?.get('carrier_id')!.updateValueAndValidity();
      this.carrierForm?.get('carrier_id')!.setValue(null);
      this.carrierForm?.get('delivery_charges')!.setValue(0);
    } else {
      this.carrierForm?.get('carrier_id')!.setValidators(Validators.required);
      this.isCarrierSelected = null
      this.is_selected = false;

      // Restore previous values when unchecking
      if (this.previousCratesValue !== null) {
        this.carrierForm?.get('crates')!.setValue(this.previousCratesValue);
      }
      if (this.previousDeliveryChargesValue !== null && this.is_selected_addtional_charge) {
        this.carrierForm?.get('delivery_charges')!.setValue(this.previousDeliveryChargesValue);
      } else if (!this.is_selected_addtional_charge) {
        this.carrierForm?.get('delivery_charges')!.setValue(null);
      }
    }
  }

    isSelectCarrier(id: any) {
        this.isCarrierSelected = id
    }

    getProduct() {
        this.isLoading = true;
        const requestParamModel = new RequestParamModel();
        requestParamModel.expands = [
            'formatHeroImage',
        ];
        requestParamModel.fields = ['id', 'family_name', 'hero_format_image', 'product_category_name'];
        requestParamModel.pageSize = 'all'
        requestParamModel.addDefaultFilter('type', Constants.SURFACE_SORT_NAME, 'number');
        requestParamModel.sortChange('family_name', 'asc');
        this.productService.getProduct(requestParamModel).subscribe((data: any) => {
            const updatedList = data.data.map((element: any) => {
                return {
                    ...element,
                    search_keyboard: element.family_name + ' - ' + element.product_category_name
                };
            });

            // this.productList = [...updatedList];
            this.changeDetection.detectChanges();
            this.isLoading = false;
        }, (error: any) => {
            this.isLoading = false;
        });
    }

    additionalCharge(event: Event) {
        if (this.is_selected) return;
        const checkbox = event.target as HTMLInputElement;
        this.is_selected_addtional_charge = checkbox.checked;

        if (!checkbox.checked) {
            // Store current value before clearing
            this.previousDeliveryChargesValue = this.carrierForm?.get('delivery_charges')!.value;

            this.carrierForm?.get('delivery_charges')!.clearValidators();
            this.carrierForm?.get('delivery_charges')!.setErrors(null);
            this.carrierForm?.get('delivery_charges')!.updateValueAndValidity();
            this.carrierForm.get('delivery_charges')?.reset();
        } else {
            this.carrierForm?.get('delivery_charges')!.setValidators(Validators.required);
            // Restore previous value when checking
            if (this.previousDeliveryChargesValue !== null) {
                this.carrierForm?.get('delivery_charges')!.setValue(this.previousDeliveryChargesValue);
            }
        }
    }
    /************************************
     * Other functions end
     ************************************/

}
